/**
 * The page is imported from **its own module**, not from the `@pages` barrel.
 *
 * The barrel re-exports every page, so a route importing it pulls all of them into one shared chunk
 * that the entry then preloads — code-splitting by route, defeated by one import.
 */
import { createFileRoute } from '@tanstack/react-router';

import { ReferencePage } from '@pages/reference';
import { IamService } from '@units/iam';

/**
 * `/reference` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * The reference data the registers classify by.
 *
 * The screen behind it is a placeholder today, and the guard is not: somebody without
 * `reference:read` is stopped here, before anything renders, exactly as they will be once the real
 * screen replaces the placeholder. Little about this file changes when it does — the search schema
 * and the loader arrive, the guard stays.
 */
export const Route = createFileRoute('/_authenticated/reference')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'reference:read',
    // The section is in the navigation of everybody who holds the right to it, so its existence is
    // no secret inside the organization and the refusal may name what is missing. The documents
    // *inside* it are the closed contour, and answer 404 (`rules/permissions.mdc`).
    whenDenied: 'forbidden',
  }),
  component: ReferencePage,
  staticData: { crumbKey: 'nav.reference' },
});
